
const SERVER_ENV = process.env.VUE_APP_SEVERENV
import { isLeYou } from './constant'

const host_beta = {
    mainHost: isLeYou ? '//portal.leyou.com' :'//portal.haiziwang.com',
    mainContentPath: '/portal-api',
    verifycodeHost:  isLeYou ? '//verifycode.leyou.com' :'//verifycode.haiziwang.com',
    cmsHost: '//cms.haiziwang.com',
    partnerHost: '//test.partner.haiziwang.com',
    verifycodeHost:  isLeYou ? '//verifycode.leyou.com' :'//verifycode.haiziwang.com',
    mapi: 'https://mapi.haiziwang.com',
    bcomment: '//bcomment.haiziwang.com',
    article: '//apiart.haiziwang.com',
    canvass: '//test.hbpcollege.haiziwang.com',
    adwords: '//test.hbpcollege.haiziwang.com'
}

const host_idc = {
    mainHost: isLeYou ? '//portal.leyou.com' :'//portal.haiziwang.com',
    mainContentPath: '/portal-api',
    verifycodeHost:  isLeYou ? '//verifycode.leyou.com' :'//verifycode.haiziwang.com',
    cmsHost: '//cms.haiziwang.com',
    partnerHost: '//partner.haiziwang.com',
    verifycodeHost:  isLeYou ? '//verifycode.leyou.com' :'//verifycode.haiziwang.com',
    mapi: 'https://mapi.haiziwang.com',
    bcomment: '//bcomment.haiziwang.com',
    article: '//apiart.haiziwang.com',
    canvass: '//hbpcollege.haiziwang.com',
    adwords: '//hbpcollege.haiziwang.com'
}

const host = SERVER_ENV === 'BETA' ? host_beta : host_idc

export default host

let portal_api = {
    queryAccountInfo:'/account/queryAccountInfo.do',//查询用户信息(不校验登录态)
    queryAccountInfoNeedLogin:'/account/queryAccountInfoNeedLogin.do',//查询用户信息(校验登录态)
    bindAccount:'/account/bindAccount.do',
    logout:'/user/logout.do',
    getPortalMenu:`/user/getPortalMenu.do?t=${new Date().getTime()}`
}

Object.entries(portal_api).forEach(([key,value])=>{
    value = `${host.mainHost}${host.mainContentPath}${value}`
    Reflect.set(portal_api, key, value);
})
export const portalApi = portal_api
